import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

import type { AgentTitleAreaBannerProps } from './AgentTitleAreaBanner.tsx';

export const LazyAgentTitleAreaBanner: LoadableType<AgentTitleAreaBannerProps> = LoadableBackground(
	{
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-AgentTitleAreaBanner" */ './AgentTitleAreaBanner.tsx'
				)
			).AgentTitleAreaBannerErrorBoundary,
	},
);
